import React from 'react';
import { notifications } from '@mantine/notifications';
import { AlertCircle, CircleCheck } from 'tabler-icons-react';
import { theme } from '../styles/theme';

const triggerNotification = (message, title, notificationColor) => {
  let variantData = {};
  switch (title?.toLowerCase()) {
    case 'success':
      variantData = {
        color: '#067D62',
        title: 'Success',
        icon: <CircleCheck />
      };
      break;
    case 'warning':
      variantData = {
        color: '#eca70a',
        title: 'Warning',
        icon: <AlertCircle />
      };
      break;
    default:
      variantData = {
        color: '#c40000',
        title: 'Error',
        icon: <AlertCircle />
      };
  }

  const color = notificationColor ?? 'red';
  const icon =
    notificationColor === 'green' ? <CircleCheck /> : <AlertCircle />;

  if (notificationColor) {
    notifications.show({
      id: 'app-notification',
      withCloseButton: true,
      title: title ?? 'Error',
      message: message ?? 'Oops something went wrong!',
      color,
      icon,
      className: 'my-notification-class',
      styles: {
        root: {
          backgroundColor: theme.colors[color][6],
          borderColor: theme.colors[color][6]
        },
        title: { color: '#FFF' },
        description: { color: '#FFF' },
        closeButton: { color: '#FFF' }
      }
    });
  }
  else {
    notifications.show({
      withCloseButton: true,
      title: variantData.title,
      message: message ?? 'Oops something went wrong!',
      color: variantData.color,
      icon: variantData.icon,
      withBorder: true,
      styles: {
        root: {
          backgroundColor: variantData.color,
          borderColor: variantData.color
        },
        title: { color: '#FFF' },
        description: { color: '#FFF' },
        closeButton: { color: '#FFF' }
      }
    });
  }
};

export { triggerNotification };
